import { useState, useEffect } from 'react'

export const CheckboxMultiselect = (props) => {

  const [ value, setValue ] = useState(props.value ? props.value.split(',') : [])

  useEffect(() => props.onChange ? props.onChange(value.toString()) : null, [value])

  return (
    <div className="tf-custom-checkbox-multiselect">
      <div className="tf-label" >{ props.label ?? '' }</div>
      <input type="hidden" name={ props.name ?? '' } value={ value.toString() } />
      <div className="tf-custom-checkbox-multiselect__choices">
        { Object.keys(props.choices).map( val => <label
          key={val}
          aria-label={props.ariaLabels && props.ariaLabels[val] ? props.ariaLabels[val] : ''}
          role={props.ariaLabels && props.ariaLabels[val] ? "tooltip" : ''}
          data-tgbl-microtip-position="top"
        >
          <input
            type="checkbox"
            checked={value.includes(val)}
            onChange={() => setValue(prev => prev.includes(val) ? prev.filter(i => i !== val) : [ ...prev, val ])}
          />
          <span>{props.choices[val]}</span>
        </label>) }
      </div>
      <div className="tf-description" >{ props.description ?? '' }</div>
    </div>
  )
}
